import { ISetNameParams } from '../types/actionParams';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export class RenameViewRequest extends Request<ISetNameParams, IEmptyResult> {
  constructor(id: string, name: string) {
    super('renameView', {
      id: id,
      name: name
    });
  }
}
